import DefaultValidation from "@/services/validations/DefaultValidation";
import Message from '@/models/Message';
import { isNull } from "@/functions/Util";

export default class TabPrecoValidation extends DefaultValidation {

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;

        Object.entries(model).forEach(([key, value]) => {
            if (value != null && typeof value == "string") model[key] = value.trim();
        });

        if (isNull(model.descricao)) {
            refs.descricaoInput.focusedOut = true;
            validated = false;
        }

        if (isNull(model.porcacrescflex)) {
            refs.porcentualDescontoFlexInput.focusedOut = true;
            validated = false;
        }

        if (isNull(model.idtabprecodescontopai)) {
            refs.idTabelaPrecoPai.focusedOut = true;
            validated = false;
        }

        if (isNull(model.idtabprecoerp)) {
            refs.idErpInput.focusedOut = true;
            validated = false;
        }

        if (!validated) {
            this.showMessage(new Message("alert", "msg-campos-obrigatorios", true));
        }

        if (model.porcacrescflex < 0 || model.porcacrescflex > 100) {
            this.showMessage(new Message("alert", "minimo-maximo-porcentual-flex", true));
            return false;
        }

        if (model.descprodutoqtde < 0 || model.descprodutoqtde > 100) {
            this.showMessage(new Message("alert", "minimo-maximo-desconto-tabela-preco", true));
            return false;
        }

        if (!model.datavalidade) {
            this.showMessage(new Message("alert", "selecione-uma-data", true));
            return false;
        }

        if (isNull(model.idempresa)) {
            this.showMessage(new Message("alert", "necessario-empresa", true))
            return false;
        }

        if (isNull(model.idmoeda)) {
            this.showMessage(new Message("alert", "necessario-moeda", true))
            return false;
        }

        return validated;
    }
}